<!-- =========================================================================================
    File Name: Explore.vue
    Description: Explore panel to select guided tags
    ----------------------------------------------------------------------------------------
    Item Name: NexSat
    Author: Anand
========================================================================================== -->

<template>
  <div id="stock-view">
    <div class="mb-base">
      <div class="flex md:items-end items-center justify-between flex-wrap">
        <div class="flex justify-between items-end flex-grow">
          <p class="lg:inline-flex hidden font-semibold">Apply filters and choose your view</p>

          <div class="flex flex-wrap">
            <!-- Filter -->
            <!-- <vs-select
              :value="currentFilter"
              class="mr-4 vs-input-shadow-drop vs-select-no-border d-theme-input-dark-bg w-48"
            >
              <vs-select-item value="all" text="All SKUs"/>
              <vs-select-item value="competitive" text="Competitive SKUs" />
              <vs-select-item value="need_action" text="SKUs Need Action" />
              <vs-select-item value="exceptions" text="SKUs With Issues" />
            </vs-select>-->

            <!-- ITEM VIEW - GRID/LIST -->
            <div>
              <feather-icon
                icon="GridIcon"
                @click="changeView('item-grid-view')"
                class="p-2 shadow-drop rounded-lg d-theme-dark-bg cursor-pointer"
                :svgClasses="{'text-primary stroke-current': currentItemView == 'item-grid-view'}"
              />
              <feather-icon
                icon="FilterIcon"
                @click="changeView('item-list-view')"
                class="p-2 ml-4 shadow-drop rounded-lg d-theme-dark-bg cursor-pointer hidden sm:inline-flex"
                :svgClasses="{'text-primary stroke-current': currentItemView == 'item-list-view'}"
              />
              <feather-icon
                icon="UploadIcon"
                @click="addNewData"
                class="p-2 ml-4 shadow-drop rounded-lg d-theme-dark-bg cursor-pointer hidden sm:inline-flex"
                :svgClasses="{'text-primary stroke-current': currentItemView == 'item-manage-view'}"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="mb-base">
      <!-- JUMBOTRON -->
      <template v-if="currentItemView === 'item-grid-view'">
        <div class="mb-base">
          <div class="rounded-lg mb-base">
            <vs-input
              placeholder="Search by sku name, brand or category"
              v-model="stockSearchQuery"
              icon-pack="feather"
              icon="icon-search"
              size="large"
              class="w-full no-icon-border mt-6"
              @input="debounceQueryStock"
            />
            <!-- v-debounce:300ms="queryStock" -->
          </div>
          <div class="flex flex-wrap items-center md:justify-between mb-base">
            <div class="flex flex-wrap">
              <span class="lg:inline-flex hidden font-semibold pr-4">Search by</span>
              <vs-chip
                @click="applyFilter(tag)"
                class="cursor-pointer"
                :class="selectedTag(tag)"
                closable
                :close-icon="selectedIcon(tag)"
                v-for="(tag, index) in searchTags"
                :key="index"
              >{{ tag.tag }}</vs-chip>
            </div>
          </div>
        </div>
      </template>
      <template v-else-if="currentItemView === 'item-list-view'">
        <div class="mb-base">
          <div class="rounded-lg mb-base">
            <multiselect
              v-model="multiselect.exploreTags"
              id="ajax"
              label="tag"
              track-by="tag"
              placeholder="Type here to explore"
              open-direction="bottom"
              :options="multiselect.tags"
              :multiple="true"
              :searchable="true"
              :loading="multiselect.isLoading"
              :internal-search="true"
              :clear-on-select="true"
              :close-on-select="false"
              :max="5"
              :options-limit="50"
              :limit="5"
              :limit-text="limitText"
              :max-height="600"
              :show-no-results="true"
              :hide-selected="true"
              @search-change="queryTags"
              @input="init()"
              class="w-full no-icon-border mt-6"
              disabled="true"
            >
              <template slot="tag" slot-scope="{ option, remove }">
                <vs-chip
                  transparent
                  @click="remove(option), init()"
                  :color="option.type !== 'S' ? '' : 'primary'"
                  type="gradient"
                  v-bind="{closable : option.type !== 'S'}"
                >
                  <vs-avatar
                    :text="option.type !== 'S' ? option.type : ''"
                    icon="icon-map-pin"
                    icon-pack="feather"
                  />
                  {{ option.tag }}
                </vs-chip>
              </template>
              <template slot="option" slot-scope="props">
                <div class="flex justify-between">
                  <span class="option__title">{{ props.option.tag | ellipsis(50) }}</span>
                  <vs-chip>{{ multiselect.tagTypes[props.option.type] }}</vs-chip>
                </div>
              </template>
              <template slot="clear" slot-scope="props">
                <div
                  class="multiselect__clear"
                  v-if="multiselect.exploreTags.length"
                  @mousedown.prevent.stop="clearAll(props.search)"
                ></div>
              </template>
              <span slot="noResult">Oops! No elements found. Consider changing the search query.</span>
            </multiselect>
          </div>
          <div class="flex flex-wrap items-center md:justify-between mb-base">
            <div class="flex flex-wrap">
              <span class="lg:inline-flex hidden font-semibold pr-4">Filter by</span>
              <template>
                <vx-tooltip :text="tag.desc" v-for="(tag, index) in searchModes" :key="index">
                  <vs-avatar
                    badge-color="rgb(140, 23, 164)"
                    :badge="getStat(tag)"
                    @click="applyMode(tag)"
                    :color="tag.status ? 'primary': 'grey'"
                    icon-pack="feather"
                    :icon="tag.icon"
                  >{{tag.tag}}</vs-avatar>
                </vx-tooltip>
              </template>
              <!-- <feather-icon
                  :icon="tag.icon"
                  @click="applyMode(tag)"
                  class="p-2 ml-4 shadow-drop rounded-lg d-theme-dark-bg cursor-pointer"
                  :svgClasses="{'text-primary stroke-current': tag.status}"
                  :badge="8943" 
                  v-for="(tag, index) in searchModes" 
                  :key="index"
              />-->
              <!-- <vs-chip @click="applyMode(tag)" class="cursor-pointer" :class="selectedTag(tag)" closable :close-icon="selectedIcon(tag)" v-for="(tag, index) in searchModes" :key="index" :badge="1" >
                  {{ tag.tag }}
              </vs-chip>-->
            </div>
          </div>
          <!-- <div id="competer-app">
            <explore></explore>
            <guide :data="guide" :key="guide.type" :flag="stock.length === 0"></guide>
          </div>-->
          <!-- <item-list-view :stock="stock"></item-list-view> -->
        </div>
      </template>
      <template v-else-if="currentItemView === 'item-manage-view'">
        <div class="mt-base">
          <item-manage-view></item-manage-view>
        </div>
      </template>
      <template>
        <div class="items-grid-view vx-row match-height">
          <vs-alert
            active="true"
            color="warning"
            class="mb-base m-5"
            icon-pack="feather"
            icon="icon-alert-triangle"
            v-if="!callInProgress && stock.length === 0"
          >
            <p>No data found for the filter criteria used. Kindly adjust the search filter and try again.</p>
          </vs-alert>
          <div
            class="vx-col lg:w-1/4 md:w-1/3 sm:w-1/2 w-full"
            v-for="(item, index) in stock"
            :key="index"
          >
            <item-grid-view :item="item">
              <!-- SLOT: ACTION BUTTONS -->
              <template slot="action-buttons">
                <div class="flex flex-wrap">
                  <!-- PRIMARY BUTTON : REMOVE -->
                  <div
                    class="item-view-primary-action-btn p-3 flex flex-grow items-center justify-center cursor-pointer"
                    @click="removeItemFromWishList(item)"
                  >
                    <feather-icon icon="SearchIcon" svgClasses="h-4 w-4" />

                    <span class="text-sm font-semibold ml-2">Retailers Scan</span>
                  </div>

                  <!-- SECONDARY BUTTON: MOVE TO CART -->
                  <div
                    class="item-view-secondary-action-btn bg-primary p-3 flex flex-grow items-center justify-center text-white cursor-pointer"
                    @click="showTrend(item, index)"
                  >
                    <feather-icon icon="TrendingUpIcon" svgClasses="h-4 w-4" />

                    <span class="text-sm font-semibold ml-2">Show Trend</span>
                  </div>
                </div>
              </template>
            </item-grid-view>
          </div>
        </div>
      </template>
      <scroll-loader :loader-method="getStockInfo" :loader-enable="loadMore"></scroll-loader>

      <manage-stock
        :isSidebarActive="addNewDataSidebar"
        @closeSidebar="toggleDataSidebar"
        :data="sidebarData"
      />
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

import Multiselect from "vue-multiselect";
import ScrollLoader from "vue-scroll-loader";
import VuePerfectScrollbar from "vue-perfect-scrollbar";

//you need to import the CSS manually (in case you want to override it)
import "vue-multiselect/dist/vue-multiselect.min.css";

import Explore from "./Explore.vue";
import Guide from "./Guide.vue";
import Visualizer from "./Visualizer.vue";
import ManageStock from "./ManageStock.vue";

import { appCommons, appAnalyze } from "@/app/shared/services";
import { fetchTags, fetchArtefacts } from "../shared/services";

import { actionsTypes } from "../shared/state";

const ItemGridView = () => import("./ItemGridView.vue");
const ItemListView = () => import("./ItemListView.vue");
const ItemManageView = () => import("./ItemManageView.vue");

export default {
  props: {
    // artefact: { type: Object, required: true }
  },
  data() {
    return {
      currentFilter: "exceptions",
      currentItemView: this.$route.params.view ? this.$route.params.view : "item-grid-view",
      isFilterSidebarActive: true,
      clickNotClose: true,
      windowWidth: window.innerWidth,

      loadMore: true,
      callInProgress: false,
      stock: [],
      stats: [],
      stockSearchQuery: "",
      debounce: null,
      error: null,

      // Data Sidebar
      addNewDataSidebar: false,
      sidebarData: {},

      backgroundLoading: "primary",
      colorLoading: "#fff",

      payload: {
        tags: [],
        filters: [],
        dateRange: {
          startDate: "05/03/2019",
          endDate: "08/03/2019"
        },
        page: {
          size: 20,
          pos: 1
        },
        query: "",
        mode: "",
        type: "STOCK",
        res: {}
      },

      //MultiSelect Config
      multiselect: {
        exploreTags: [],
        tags: [],
        isLoading: false,
        selected: null,
        tagTypes: {
          S: "Store",
          M: "Manufacturer",
          B: "Brand",
          C: "Category",
          U: "Sku",
          G: "Sub Category",
          D: "Department"
        }
        // options: ['list', 'of', 'options'],
      },

      searchModes: [
        {
          tag: "All",
          code: "all",
          desc: "All prices combined",
          icon: "icon-shuffle",
          status: true
        },
        {
          tag: "Up",
          code: "pos",
          desc: "Market price higher than our price",
          icon: "icon-trending-up",
          status: false
        },
        {
          tag: "Down",
          code: "down",
          desc: "Market price lower than our price",
          icon: "icon-trending-down",
          status: false
        }
      ],
      searchTags: [
        {
          tag: "Product Name",
          code: "name",
          status: true
        },
        {
          tag: "Product Code",
          code: "code",
          status: true
        },
        {
          tag: "Brand",
          code: "brand",
          status: true
        },
        {
          tag: "Category",
          code: "cat",
          status: false
        },
        {
          tag: "Sub Category",
          code: "sub_cat",
          status: false
        },
        {
          tag: "Department",
          code: "dep",
          status: false
        },
        {
          tag: "Company",
          code: "company",
          status: false
        }
      ],      

    };
  },
  computed: {
    filteredStock() {
      let skus = this.stock.map(item => item[0]);
      return skus;
    },
    ...mapGetters({ artefact: "competer/artefact" })
  },
  methods: {
    // Multiselect specific methods
    limitText(count) {
      return `and ${count} other tags`;
    },
    queryTags(query) {
      this.multiselect.isLoading = true;
      fetchTags()
        .then(data => {
          this.tempTags = data.data;
          this.multiselect.tags = this.filterAndSortTags();
          this.multiselect.isLoading = false;
        })
        .catch(error => {
          this.multiselect.isLoading = false;
          throw new Error(error);
        });
    },
    clearAll() {
      this.multiselect.exploreTags = [];
    },
    bucketAndSortTags(etags) {
      let tagBucket = [];
      let i = 0;
      let len = etags.length;
      // S - STORE, M - MANUFACTURER, B - BRAND, C - CATEGORY, U - SKU, G - SUBCAT ( GROUP ), D - DEPT
      let tagBuckets = {
        B: [],
        C: [],
        U: [],
        S: [],
        M: [],
        G: [],
        D: [],
        order: "SMBCUGD"
      };

      for (; i < len; i++) {
        tagBuckets[etags[i].type].push(etags[i]);
      }

      for (let j = 0; j < tagBuckets.order.length; j++) {
        Array.prototype.push.apply(
          tagBucket,
          tagBuckets[tagBuckets.order.charAt(j)]
        );
      }

      return tagBucket;
    },
    flatTags(etags) {
      let i = 0;
      let len = etags.length;
      let flatTags = "";

      for (; i < len; i++) {
        flatTags = flatTags.concat(etags[i].tag + ", ");
      }

      return flatTags.slice(0, -2);
    },
    filterAndSortTags() {
      let filteredTags = this.tempTags;

      return filteredTags.sort(function(t1, t2) {
        var tA = t1.tag.toUpperCase();
        var tB = t2.tag.toUpperCase();
        if (tA < tB) {
          return -1;
        }
        if (tA > tB) {
          return 1;
        }

        // tags must be equal
        return 0;
      });
    },
  
    
    
    initCompete() {
      // this.$store.dispatch('competer/'+ actionsTypes.FETCH_COMPETER_GUIDE, this.payload);
      // this.$store.dispatch('competer/'+ actionsTypes.FETCH_COMPETER_ARTEFACT, this.payload);
    },
    init() {
      this.queryTags();
      this.callInProgress = false;
      this.queryStock();
    },
    selectedTag(tag) {
      return tag.status ? "bg-primary-gradient text-white" : "";
    },
    selectedIcon(tag) {
      return tag.status ? "check_box" : "check_box_outline_blank";
    },
    applyFilter(tag) {
      tag.status = !tag.status;
      this.queryStock();
    },
    applyMode(tag) {
      for (var t of this.searchModes) {
        t.status = false;
      }
      tag.status = true;
      this.queryStock();
    },
    selectedMode() {
      let tag = this.searchModes.filter(t => t.status);
      return this.currentItemView === "item-grid-view"
        ? "def"
        : tag && tag.length > 0
        ? tag[0].code
        : "all";
    },
    getStat(tag) {
      return this.stats && this.stats[tag.code] ? this.stats[tag.code] : 0;
    },
    debounceQueryStock(event) {
      clearTimeout(this.debounce)
      this.stockSearchQuery = event
      this.debounce = setTimeout(() => {
        this.queryStock()
      }, 600)
    },
    queryStock() {
      this.loadMore = true;
      this.payload.page.pos = 1;
      this.stock = [];
      this.payload.query = this.stockSearchQuery.toLowerCase();
      this.payload.tags = this.bucketAndSortTags(this.multiselect.exploreTags);

      // if((this.stockSearchQuery && this.stockSearchQuery.length > 1) || (this.payload.tags && this.payload.tags.length > 0)) {
      //   this.getStockInfo('STOCKSEARCH');
      // } else if(!this.stockSearchQuery && (!this.payload.tags || (this.payload.tags && this.payload.tags.length < 1)) &&
      //             this.selectedMode() !== 'all') {
      //   this.getStockInfo('STOCK');
      // }

      if (
        !this.stockSearchQuery &&
        (!this.payload.tags ||
          (this.payload.tags && this.payload.tags.length < 1)) &&
        this.selectedMode() === "def"
      ) {
        this.getStockInfo("STOCK");
      } else {
        this.getStockInfo("STOCKSEARCH");
      }
    },
    getStockInfo(type) {
      if (!this.callInProgress) {
        this.callInProgress = true;

        this.payload.mode = this.selectedMode();
        if (type) {
          this.payload.type = type;
        }

        this.payload.filters = this.searchTags;

        fetchArtefacts(this.payload)
          .then(res => {
            let stockOnPage = res.data.skus.map(item =>
              item._source ? item._source : item[0]
            );

            this.stock = this.stock.concat(stockOnPage);
            this.stats = res.data.stats;

            // Stop scroll-loader
            if (res.data.skus.length < Number(this.payload.page.size)) {
              this.loadMore = false;
              this.payload.page.pos = 1;
            } else {
              this.payload.page.pos++;
            }
            this.callInProgress = false;
          })
          .catch(error => {
            this.callInProgress = false;
            this.payload.page.pos = 1;
            this.loadMore = false;
            throw new Error(error);
          });
      }
    },
    showTrend(item, index) {
      this.callInProgress = true;
      appAnalyze.pendoTrack("SKU Trend", {});
      this.$router.push("/competer/sku/" + item.code);
    },
    addNewData() {
      this.sidebarData = {};
      this.toggleDataSidebar(true);
    },
    deleteData(id) {
      this.$store.dispatch("dataList/removeItem", id).catch(err => {
        console.error(err);
      });
    },
    editData(data) {
      // this.sidebarData = JSON.parse(JSON.stringify(this.blankData))
      this.sidebarData = data;
      this.toggleDataSidebar(true);
    },
    toggleDataSidebar(val = false) {
      this.addNewDataSidebar = val;
    },
    changeView(selectedView) {
      this.currentItemView = selectedView;
      this.stockSearchQuery = "";
      this.multiselect.exploreTags = [];
      for (var t of this.searchModes) {
        if (t.code === "all") {
          t.status = true;
        } else {
          t.status = false;
        }
      }
      this.init();
    }
  },
  mounted() {
    this.wasSidebarOpen = this.$store.state.reduceButton;
    this.$store.commit("TOGGLE_REDUCE_BUTTON", true);
    this.init();
    this.initCompete();

    this.$store.watch(
      (state, getters) => getters["competer/artefact"],
      (newValue, oldValue) => {
        this.payload = newValue;
        this.init();
      }
    );
  },
  beforeDestroy() {
    if (!this.wasSidebarOpen) this.$store.commit("TOGGLE_REDUCE_BUTTON", false);
  },
  watch: {
    "$store.state.AppScopeTrack"(val) {
      this.init();
    }
  },
  components: {
    ItemGridView,
    ItemListView,
    ItemManageView,
    ManageStock,
    Explore,
    Guide,
    Visualizer,
    Multiselect
  }
};
</script>

<style lang="scss" scoped>
#stock-view {
  .item-view-primary-action-btn {
    // color: #2c2c2c !important;
    // background-color: #f6f6f6;
    // min-width: 50%;
  }

  .item-view-secondary-action-btn {
    // min-width: 50%;
  }

  .knowledge-base-jumbotron-content {
    // background-image: url('/assets/images/pages/knowledge-base-cover.jpg');
    // background-size: cover;
  }
}
</style>
